export function resetSlice(state: any, initialState: any) {
  state = initialState;
  return initialState;
}
